export default __webpack_public_path__ + "images/768223f759dcd0397fc3015b36385fb8.jpg";